import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams, useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'store/hooks';
import { useApiRequest } from 'api/useApiRequest';
import {
  changeEmailByTokenAndLogin,
  reissueEmailChangeToken,
} from 'api/authApi';
import { useUnrestrictedEffect } from 'hooks/useUnrestrictedEffect';
import { restoreAuth } from 'store/reducers/userReducer';
import * as FP from 'utils/fp-js';

const defaultValues = {
  email: '',
};

export const useEmailChangePage = () => {
  const { callApiRequest } = useApiRequest();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { token } = useParams();
  const [newToken, setNewToken] = useState('');

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const {
    register,
    control,
    reset,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors, isDirty },
    trigger,
    watch,
  } = useForm({
    defaultValues,
  });

  const onSubmit = handleSubmit(({ email }) => {
    FP.asyncEither({
      value: callApiRequest({
        apiRequest: changeEmailByTokenAndLogin,
        params: {
          token: newToken,
          email,
        },
      }),
      rightFn: value => dispatch(restoreAuth(value?.refresh?.token)),
    });
  });

  useUnrestrictedEffect({
    loadFn: () => {
      FP.asyncEither({
        value: callApiRequest({
          apiRequest: reissueEmailChangeToken,
          params: {
            token,
          },
          skipErrorHandling: true,
        }),
        leftFn: () => navigate('/'),
        rightFn: value => setNewToken(value?.token),
      });
    },
  });

  return {
    onSubmit,
    isPasswordVisible,
    setIsPasswordVisible,
    errors,
    isDirty,
    trigger,
    getValues,
    setValue,
    register,
    reset,
    control,
    watch,
    newToken,
    setNewToken,
  };
};
